// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Radio_wrapper__3xhAc","radio":"Radio_radio__2EgYB","checked":"Radio_checked__2xDAs"};